import { Auth } from 'aws-amplify';
import axios from 'axios';

export const AxiosInitializer = async () => {

    axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL;

    axios.interceptors.request.use(async (config) => {

        if (!config.baseURL) {
            return config;
        }

        const session = await Auth.currentSession();

        const token = session.getIdToken().getJwtToken();
        config.headers = config.headers || {}; // Initialize headers if undefined
        config.headers['Authorization'] = token;
        return config;
    });

    axios.interceptors.response.use(function (response) {
        return response;
    }, function (error) {
        if (error.response) {
            error.message = error.response.data
        }
        return Promise.reject(error);
    });
};